import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class iren10x3Gas {
  public static offerta(): Offerte {
    return {
		Flg_Indicizzato: false,
      Id_Offerta: 128,
      Id_Foritore: 1,
      Id_comodity: 2,
      TipoContratto: 1,
      NomeOfferta: "10X3 Gas",
      LinkFoto: "./assets/images/offerte-iren/10x3gas-2.jpg",
      LinkFotoLarge: "./assets/images/offerte-iren/10x3gas-2.jpg",
      LinkFotoMid: "./assets/images/offerte-iren/10x3gas-2.jpg",
      LinkFotoSm: "./assets/images/offerte-iren/10x3gas-2.jpg",
      LinkFotoCarousel: "./assets/images/offerte-iren/10x3gas-2.jpg",
      DescrizioneCarousel: "Che Offerta super",
      DescrizioneNomeOfferta: "Usufruisci di 30€ di bonus sulla fornitura Gas",
      PromozioneOfferta: "",
      Sezioni: [
        {
          NomeSezione: "RISPARMIO ASSICURATO",
          DescrizioneSezione: "prevista l’erogazione di un Bonus pari a 30 € per ogni fornitura, suddiviso in 3 Bonus da 10 € ciascuno, che verranno accreditati al cliente con la seguente modalità: ",
          lstPunti: [" il 1° sulla bolletta del 1° mese di fornitura;", " il 2° sulla bolletta del 6° mese di fornitura; ", " il 3° sulla bolletta del 12° mese di fornitura", "Il bonus corrisponde, in termini di risparmio sulla materia  a 0,021 €/Smc    (da 0,338 a 0,317) per il cliente tipo (1.400 Smc di consumo annuo)."]

        },
      ],
      PrezzoEle: 0,
      PrezzoGas: 0.338,

      TitoloPlus: "Vantaggi assicurati",
      Plus: ["Prezzo fisso e invariabile per due anni!", "Sottoscrivendo questa proposta potrai usufruire di un Bonus pari a 30 € per ogni fornitura, suddiviso in 3 Bonus da 10 € ciascuno", "Prezzo fisso e invariabile per due anni!"]
      , schedaconfrontabilitaele:
      {
        tabellaConfrontabilita: []
      }
      , schedaconfrontabilitagas: {
        tabellaConfrontabilita: [{ zona: 1, consumoannuo: 120, importo: 122.93 }
          , { zona: 1, consumoannuo: 480, importo: 309.47 }
          , { zona: 1, consumoannuo: 700, importo: 418.42 }
          , { zona: 1, consumoannuo: 1400, importo: 765.06 }
          , { zona: 1, consumoannuo: 2000, importo: 1060.4 }
          , { zona: 1, consumoannuo: 5000, importo: 2533.79 }
          , { zona: 2, consumoannuo: 120, importo: 113.18 }
          , { zona: 2, consumoannuo: 480, importo: 290.69 }
          , { zona: 2, consumoannuo: 700, importo: 394.47 }
          , { zona: 2, consumoannuo: 1400, importo: 724.66 }
          , { zona: 2, consumoannuo: 2000, importo: 1005.86 }
          , { zona: 2, consumoannuo: 5000, importo: 2408.53 }
          , { zona: 3, consumoannuo: 120, importo: 119.41 }
          , { zona: 3, consumoannuo: 480, importo: 308.27 }
          , { zona: 3, consumoannuo: 700, importo: 418.51 }
          , { zona: 3, consumoannuo: 1400, importo: 769.26 }
          , { zona: 3, consumoannuo: 2000, importo: 1068.12 }
          , { zona: 3, consumoannuo: 5000, importo: 2559.2 }
          , { zona: 4, consumoannuo: 120, importo: 114.84 }
          , { zona: 4, consumoannuo: 480, importo: 311.77 }
          , { zona: 4, consumoannuo: 700, importo: 426.49 }
          , { zona: 4, consumoannuo: 1400, importo: 791.48 }
          , { zona: 4, consumoannuo: 2000, importo: 1102.59 }
          , { zona: 4, consumoannuo: 5000, importo: 2654.96 }
          , { zona: 5, consumoannuo: 120, importo: 127.7 }
          , { zona: 5, consumoannuo: 480, importo: 334.8 }
          , { zona: 5, consumoannuo: 700, importo: 455.16 }
          , { zona: 5, consumoannuo: 1400, importo: 838.12 }
          , { zona: 5, consumoannuo: 2000, importo: 1164.68 }
          , { zona: 5, consumoannuo: 5000, importo: 2794.4 }
          , { zona: 6, consumoannuo: 120, importo: 134.84 }
          , { zona: 6, consumoannuo: 480, importo: 360.03 }
          , { zona: 6, consumoannuo: 700, importo: 490.44 }
          , { zona: 6, consumoannuo: 1400, importo: 905.39 }
          , { zona: 6, consumoannuo: 2000, importo: 1259.45 }
          , { zona: 5, consumoannuo: 5000, importo: 3026.88 }]
      }

      , lstModalitaPagamento: ["1", "2"]
      , scontoRid: 0
      , TipoSoglieEle: Soglie.SogliaMomoEleOld()
      ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/iren10x3Gas.ts